export default __webpack_public_path__ + "static/portfolio-mas-5-bc3e7c9bebee4e888087ed8a59eb50cd.jpg";